module.exports = __webpack_public_path__ + "img/icon3.b58a1055.svg";